<template>
    <div>
        <Loader v-if="loading" />
        <div v-else>
            <div class="container-fluid mt-45">
                <div class="row">
                    <div class="col-md-6">
                        <Breadcrumbs />
                    </div>

                    <div class="col-md-6 text-right">
                        <button @click="cancelTest()" class="btn btn-danger btn-cancel-test btn-block-mobile btn-lg lg-shadow mt-4 mt-md-0">Cancel test</button>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col">
                        <div class="card pb-4">
                            <div class="card-body">
                                <h5>Please enter the device number<span class="text-danger">*</span></h5>
                                <p class="text-sm">The device number is found on the outside of the text box.</p>

                                <div class="row mt-4">
                                    <div class="col-lg-3">
                                        <input ref="input" type="text" class="form-control" :class="{'border border-danger' : (!isDeviceValid && deviceHasBeenChecked) || error}" placeholder="123456" v-model="deviceIdComputed">
                                        <small v-if="!isDeviceValid && deviceHasBeenChecked" class="text-danger mt-1">
                                            This device number has already been registered
                                        </small>
                                        <small v-if="error" class="text-danger mt-1">
                                            This field is required
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fixed-bottom bg-white py-25">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col text-right center-mobile">
                            <router-link :to="{name: 'TestDetails'}" class="btn btn-cancel btn-lg px-5 lg-shadow">Back</router-link>
                            <button @click="next()" class="btn btn-success btn-lg px-6 lg-shadow ml-2">Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import axios from 'axios'
import Loader from '../../../Common/components/Loader.vue'
import Breadcrumbs from '@/partials/site-structure/BreadcrumbsComponent.vue'
import CancelTestModalComponent from '@/components/modals/CancelTestModalComponent.vue'
export default {
    name: 'DeviceNumber',

    components: {
        Loader,
        Breadcrumbs
    },

    data() {
        return {
            loading: false,
            isDeviceValid: false,
            deviceHasBeenChecked: false,
            error: false,
            CancelTestModalComponent
        }
    },

    mounted() {
        if(!this.patientName && !this.facilityId && !this.patientId && !this.patientTitle && !this.dueDate && !this.reason && this.method !== 0) {
            return this.$router.push({name: 'Dashboard'})
        }

        this.$refs.input.focus()
    },

    computed: {
        ...mapGetters({
            patientName: 'TestStore/GetPatientName',
            facilityId: 'TestStore/GetFacilityId',
            patientId: 'TestStore/GetPatientId',
            patientTitle: 'TestStore/GetPatientTitle',
            dueDate: 'TestStore/GetDueDate',
            reason: 'TestStore/GetReason',
            method: 'TestStore/GetMethod',
            deviceId: 'TestStore/GetDeviceId'
        }),

        deviceIdComputed: {
            get: function() {
                return this.deviceId
            },

            set: function(val) {
                this.setDeviceIdInTestStore(val)
            }
        }
    },

    methods: {
        ...mapActions({
            setDeviceIdInTestStore: 'TestStore/SetDeviceId',
            setNotification: 'NotificationStore/SetNotification'
        }),

        async next() {
            this.error = false
            
            if(!this.deviceId) {
                this.error = true
            }

            if(!this.error) {
                this.loading = true
                this.deviceHasBeenChecked = false
                
                try {
                    let response = await axios.get(`${process.env.VUE_APP_AXIOS_DIAGNOSTIC_BASE_URL}/api/v1/devices/validate/${this.deviceId}`)

                    this.deviceHasBeenChecked = true
                    this.isDeviceValid = response.data
                }
                catch(err) {
                    this.setNotification({
                        type: 'error',
                        title: 'Error',
                        message: 'Something went wrong'
                    })
                }
                finally {
                    this.loading = false
                }

                if(this.isDeviceValid && this.deviceHasBeenChecked) {                
                    return this.$router.push({name: 'Confirmation'})
                }
            }
        },

        cancelTest() {
            this.$modal.show(CancelTestModalComponent, {}, {width: '400px'});
        }
    }
}
</script>